import { requestGet } from '@/common/request';
interface ResultData {
  code: string;
  desc: string;
  isSubscribe: number;
  marketDesc: string;
  marketLink: string;
  marketImg: string;
}

/**
 * 消息中心
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1306832381&spaceEditingRestriction=true
 */
export default function genericMsgListSubcribe(): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/message/queryMarketTypeConfig');
}
